import { Box, Toolbar } from "@mui/material";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import TopBar from "../components/TopBar";
import ResponsiveDrawer from "../components/ResponsiveDrawer";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { TOP_BAR_HEIGHT, CONTENT_OFFSET } from "../constants/appConstants";


const MainLayout = () => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    return (
        <Box sx={{ display: "flex" }}>
            <TopBar
                title="Přátelé z Pomoraví"
                showMenuButton={!isDesktop}
                onMenuClick={handleDrawerToggle}
            />

            <ResponsiveDrawer
                mobileOpen={mobileOpen}
                handleDrawerToggle={handleDrawerToggle}
            />

            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    p: 3,
                    ml: `${CONTENT_OFFSET}px`,
                }}
            >
                <Toolbar sx={{ height: TOP_BAR_HEIGHT }} />
                <Outlet />
            </Box>
        </Box>
    );
};

export default MainLayout;